import React from 'react'

import { palette } from '@centivo/react-components'

import {
  InstancesContainer,
  TestimonialInstanceContainer,
  TestimonialsContent,
  TestimonialsContentSection,
  TestimonialsSubtitle,
  TestimonialsTitle,
} from './Testimonial.styled'

const Testimonial: React.FC<{
  borderColor: string
  text: string
}> = ({ borderColor, text }) => (
  <TestimonialInstanceContainer borderColor={borderColor}>
    <span> {text} </span>
  </TestimonialInstanceContainer>
)

export const Testimonials: React.FC = () => (
  <TestimonialsContent>
    <TestimonialsContentSection>
      <TestimonialsTitle>Testimonials</TestimonialsTitle>
      <TestimonialsSubtitle>
        See what our Centivo members have to say
      </TestimonialsSubtitle>

      <InstancesContainer>
        <Testimonial
          borderColor={palette.brand.teal}
          text={
            '“There were no unexpected costs and we knew everything up front, ' +
            'so there was no financial burden on us.”'
          }
        />
        <Testimonial
          borderColor={palette.brand.yellow}
          text="“I feel like I can take care of myself and my family without being in debt. Thank you!”"
        />
        <Testimonial
          borderColor={palette.brand.pink}
          text={
            '“I feel like my health plan is my partner and not my enemy. ' +
            'In the past, I used to have to fight with them all the time.”'
          }
        />
      </InstancesContainer>
    </TestimonialsContentSection>
  </TestimonialsContent>
)
